import { DisplayAvatar, DisplayAvatarProps } from "./DisplayAvatar";

type UserAvatarProps = Pick<DisplayAvatarProps, "size"> & {
  user: {
    name: string | null;
    email?: string | null;
    photo_url?: string | null;
  };
  className?: string;
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  size,
  className,
}) => {
  return (
    <DisplayAvatar
      text={user.name || user.email || "?"}
      picture={user.photo_url}
      size={size}
      className={className}
    />
  );
};
